module.exports = __webpack_public_path__ + "img/023-cocos-island.b257b605.svg";